<template>
  <div id="ProjectViewCommont">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">{{number}} {{text}}</span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row">
          <pre>{{content ? content : '无' }}</pre>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import { isObject } from 'lodash';
export default {
  name: 'ProjectViewCommont',
  props: {
    content: {
      required: true
    },
    title: {
      default: function() {
        return '';
      }
    }
  },
  components: {
    ebPanel,
    ebPanelHeader
  },
  data() {
    return {
      number: '',
      text: ''
    };
  },
  created() {
    this.initTitle(this.title);
  },
  watch: {
    title: {
      handler: function(newVal) {
        this.initTitle(newVal);
      },
      deep: true
    }
  },
  methods: {
    initTitle: function(value) {
      if (isObject(value)) {
        if (value['text']) {
          this.text = value['text'];
        }
        if (value['number']) {
          this.number = value['number'];
        }
      } else {
        this.text = value;
      }
    }
  }
};
</script>
<style scoped lang="less">
.eb-textarea {
  margin-top: 10px;
}
</style>
